/**
 * Girilen tutarın referans para birimi. Diğer locale fiyatları bu para birimine göre hesaplanacak.
 */
export const APP_PRICE_CURRENCIES: { value: string; label: string }[] = [
  { value: 'USD', label: 'USD - Amerikan Doları' },
  { value: 'EUR', label: 'EUR - Euro' },
  { value: 'GBP', label: 'GBP - İngiliz Sterlini' },
  { value: 'TRY', label: 'TRY - Türk Lirası' },
  { value: 'JPY', label: 'JPY - Japon Yeni' },
  { value: 'CNY', label: 'CNY - Çin Yuanı' },
  { value: 'AUD', label: 'AUD - Avustralya Doları' },
  { value: 'CAD', label: 'CAD - Kanada Doları' },
  { value: 'CHF', label: 'CHF - İsviçre Frangı' },
  { value: 'BRL', label: 'BRL - Brezilya Realı' },
  { value: 'INR', label: 'INR - Hindistan Rupisi' },
  { value: 'KRW', label: 'KRW - Güney Kore Wonu' },
  { value: 'MXN', label: 'MXN - Meksika Pesosu' },
  { value: 'RUB', label: 'RUB - Rus Rublesi' },
];

/** Eski kayıtlarla uyumluluk: bilinen fiyatlar için legacy value. */
const LEGACY_PRICE_TIER_VALUES: Record<string, string> = {
  '0.99': 'tier_1',
  '1.99': 'tier_2',
  '2.99': 'tier_3',
  '4.99': 'tier_4',
  '9.99': 'tier_5',
  '19.99': 'tier_6',
};

function buildAppPriceTiers(): { value: string; label: string; labelKey?: string }[] {
  const tiers: { value: string; label: string; labelKey?: string }[] = [
    { value: 'free', label: 'Ücretsiz', labelKey: 'priceTiers.free' },
  ];
  // $0.99 … $199.99 (her $1)
  for (let dollars = 0; dollars <= 199; dollars++) {
    const price = `${dollars}.99`;
    const value = LEGACY_PRICE_TIER_VALUES[price] ?? `price_${dollars}_99`;
    tiers.push({ value, label: `≈ $${price}` });
  }
  return tiers;
}

/**
 * App Store / Play Store uyumlu fiyat kademeleri (gösterim için).
 * Gerçek para birimi mağaza tarafından bölgeye göre belirlenir.
 * Değerler: free | tier_1..tier_6 (legacy) | price_{n}_99
 */
export const APP_PRICE_TIERS: { value: string; label: string; labelKey?: string }[] = buildAppPriceTiers();

export const SUBSCRIPTION_DURATIONS: { value: string; label: string; labelKey: string }[] = [
  { value: 'P1W', label: '1 hafta', labelKey: 'priceTiers.weekly' },
  { value: 'P1M', label: '1 ay', labelKey: 'priceTiers.monthly' },
  { value: 'P3M', label: '3 ay', labelKey: 'priceTiers.every3Months' },
  { value: 'P6M', label: '6 ay', labelKey: 'priceTiers.every6Months' },
  { value: 'P1Y', label: '1 yıl', labelKey: 'priceTiers.yearly' },
];
